import React from "react";
import { NavLink } from "react-router-dom";

const HRTabSidebar = ({ iconColor, isActive }) => {
  console.log(isActive);
  return (
    <div
      className={`tab-pane fade ${isActive ? "show active" : ""}`}
      id="tab_hrms"
      role="tabpanel"
    >
      {/* <h6 className="fl-title title-font ps-2 small text-uppercase text-muted" style={{ "--dynamic-color": "var(--theme-color1)" }}>Usual</h6> */}
      <ul className={`list-unstyled mb-4 menu-list ${iconColor}`}>
        {/* <li>
                <NavLink to="/index-hr" aria-label="HRMS Dashboard">
                    <svg className="svg-stroke" xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M5 12l-2 0l9 -9l9 9l-2 0"></path>
                        <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path>
                        <path d="M10 12h4v4h-4z"></path>
                    </svg>
                    <span className="mx-3">HR Dashboard</span>
                </NavLink>
            </li>
            <li>
                <NavLink to="/hrms" aria-label="hrms">
                    <svg className="svg-stroke" xmlns="http://www.w3.org/2000/svg"  width="24"  viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M7 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                        <path d="M5 22v-5l-1 -1v-4a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4l-1 1v5" />
                        <path d="M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                        <path d="M15 22v-4h-2l2 -6a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1l2 6h-2v4" />
                    </svg>
                    <span className="mx-3">HRMS</span>
                </NavLink>
            </li>
            <li>
                <a href="#DutyMenu" data-bs-toggle="collapse" aria-expanded="false" className="dropdown-toggle" aria-label="Users">
                    <svg xmlns="http://www.w3.org/2000/svg" className="svg-stroke" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M3 12a9 9 0 0 0 5.998 8.485m12.002 -8.485a9 9 0 1 0 -18 0" />
                        <path d="M12 7v5" /><path d="M12 15h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2" />
                        <path d="M18 15v2a1 1 0 0 0 1 1h1" />
                        <path d="M21 15v6" />
                    </svg>
                    <span className="mx-3">Duty Changes</span>
                </a>
                <ul className="collapse list-unstyled" id="DutyMenu">
                    <li><NavLink to="/duty-assigned-list" aria-label="Assigned List">Assigned List</NavLink></li>
                    <li><NavLink to="/duty-shift-list" aria-label="Hotel Images">Shift List</NavLink></li>
                    <li><NavLink to="/duty-roster-list" aria-label="Hotel Images">Roster List</NavLink></li>
                </ul>
            </li>
            <li className="py-2 mt-2">
                <h6 className="fl-title title-font ps-2 small text-uppercase text-muted" style={{"--dynamic-color": "var(--theme-color1)"}}>Employees [ <strong>58</strong> ]</h6>
                <ul className="list-unstyled">
                    <li><NavLink to="/employees-all" aria-label="All Employees">All Employees</NavLink></li>
                    <li><NavLink to="/employees-leave" aria-label="Leave Tracking">Leave Tracking</NavLink></li>
                    <li><NavLink to="/employees-attendance" aria-label="Employees Attendance">Attendance</NavLink></li>
                    <li><NavLink to="/employees-departments" aria-label="Departments">Departments</NavLink></li>
                    <li><NavLink to="/employees-loan" aria-label="Employees Loan">Employees Loan</NavLink></li>
                    <li><NavLink to="/employees-appraisal" aria-label="Appraisal">Appraisal</NavLink></li>
                    <li><NavLink to="/employees-add" className="fw-bold" aria-label="New Project">Add Employees</NavLink></li>
                </ul>
            </li>
            <li className="py-2 mt-2">
                <h6 className="fl-title title-font ps-2 small text-uppercase text-muted" style={{"--dynamic-color": "var(--theme-color1)"}}>Payroll</h6>
                <ul className="list-unstyled">
                    <li><NavLink to="/payroll-employee-salary" aria-label="Employee Salary">Employee Salary</NavLink></li>
                    <li><NavLink to="/payroll-payslip" aria-label="payslip">Payslip</NavLink></li>
                    <li><NavLink to="/payroll-report" aria-label="General Settings">Report</NavLink></li>
                </ul>
            </li> */}

        <li>
          <NavLink to="/hrms-dashboard" aria-label="HRMS Dashboard">
            <svg
              className="svg-stroke"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              viewBox="0 0 24 24"
              stroke="currentColor"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M5 12l-2 0l9 -9l9 9l-2 0"></path>
              <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path>
              <path d="M10 12h4v4h-4z"></path>
            </svg>
            <span className="mx-3">HRMS Dashboard</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/devices" aria-label="Devices">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-fingerprint-icon lucide-fingerprint svg-stroke"
            >
              <path d="M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4" />
              <path d="M14 13.12c0 2.38 0 6.38-1 8.88" />
              <path d="M17.29 21.02c.12-.6.43-2.3.5-3.02" />
              <path d="M2 12a10 10 0 0 1 18-6" />
              <path d="M2 16h.01" />
              <path d="M21.8 16c.2-2 .131-5.354 0-6" />
              <path d="M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2" />
              <path d="M8.65 22c.21-.66.45-1.32.57-2" />
              <path d="M9 6.8a6 6 0 0 1 9 5.2v2" />
            </svg>
            <span className="mx-3">Devices</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/employee-management" aria-label="Employee Management">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-user-plus-icon lucide-user-plus svg-stroke"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="19" x2="19" y1="8" y2="14" />
              <line x1="22" x2="16" y1="11" y2="11" />
            </svg>
            <span className="mx-3">Employees</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/duty-roster" aria-label="Duty Roster">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-clipboard-list-icon lucide-clipboard-list svg-stroke"
            >
              <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
              <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
              <path d="M12 11h4" />
              <path d="M12 16h4" />
              <path d="M8 11h.01" />
              <path d="M8 16h.01" />
            </svg>
            <span className="mx-3">Duty Roster</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/live-logs" aria-label="Live Logs">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-bell-icon lucide-bell svg-stroke"
            >
              <path d="M10.268 21a2 2 0 0 0 3.464 0" />
              <path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" />
            </svg>
            <span className="mx-3">Live Logs</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/attendance" aria-label="Attendance">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-calendar-check-icon lucide-calendar-check svg-stroke"
            >
              <path d="M8 2v4" />
              <path d="M16 2v4" />
              <rect width="18" height="18" x="3" y="4" rx="2" />
              <path d="M3 10h18" />
              <path d="m9 16 2 2 4-4" />
            </svg>
            <span className="mx-3">Attendance</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/leave-management" aria-label="Leave Management">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-user-plus-icon lucide-user-plus svg-stroke"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="19" x2="19" y1="8" y2="14" />
              <line x1="22" x2="16" y1="11" y2="11" />
            </svg>
            <span className="mx-3">Leave Management</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/hrms-reports" aria-label="HRMS Reports">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-file-text-icon lucide-file-text svg-stroke"
            >
              <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
              <path d="M14 2v5a1 1 0 0 0 1 1h5" />
              <path d="M10 9H8" />
              <path d="M16 13H8" />
              <path d="M16 17H8" />
            </svg>
            <span className="mx-3">Reports</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/audit" aria-label="Audit">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-shield-check-icon lucide-shield-check svg-stroke"
            >
              <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
              <path d="m9 12 2 2 4-4" />
            </svg>
            <span className="mx-3">Audit</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/users" aria-label="Users">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-users-icon lucide-users svg-stroke"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <path d="M16 3.128a4 4 0 0 1 0 7.744" />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <circle cx="9" cy="7" r="4" />
            </svg>
            <span className="mx-3">Users</span>
          </NavLink>
        </li>
        {/* <li>
                    <NavLink to="/email-logs" aria-label="Email Logs">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-mail-icon lucide-mail svg-stroke">
                            <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
                            <rect x="2" y="4" width="20" height="16" rx="2" />
                        </svg>
                        <span className="mx-3">Email Logs</span>
                    </NavLink>
                </li> */}
        <li>
          <NavLink to="/payroll" aria-label="Payroll">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="6.5" cy="9" r="3" />
              <path d="M2.8 15a5 5 0 0 1 7.4 0" />
              <rect x="12" y="4" width="9" height="14" rx="1.8" />
              <path d="M14.5 8h5" />
              <path d="M14.5 11h4" />
            </svg>

            <span className="mx-3">Payroll</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/settings" aria-label="Settings">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-settings-icon lucide-settings svg-stroke"
            >
              <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915" />
              <circle cx="12" cy="12" r="3" />
            </svg>
            <span className="mx-3">Settings</span>
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default HRTabSidebar;
//         <li>
//           <NavLink to="/hrms-dashboard" aria-label="HRMS Dashboard">
//             <svg
//               className="svg-stroke"
//               xmlns="http://www.w3.org/2000/svg"
//               width="24"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//               fill="none"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             >
//               <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
//               <path d="M5 12l-2 0l9 -9l9 9l-2 0"></path>
//               <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path>
//               <path d="M10 12h4v4h-4z"></path>
//             </svg>
//             <span className="mx-3">HRMS Dashboard</span>
//           </NavLink>
//         </li>
//         <li>
//           <NavLink to="/live-logs" aria-label="Live Logs">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="24"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               stroke-width="2"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               class="lucide lucide-bell-icon lucide-bell svg-stroke"
//             >
//               <path d="M10.268 21a2 2 0 0 0 3.464 0" />
//               <path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" />
//             </svg>
//             <span className="mx-3">Live Logs</span>
//           </NavLink>
//         </li>
//         <li>
//           <NavLink to="/audit" aria-label="Audit">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="24"
//               height="24"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               stroke-width="2"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               class="lucide lucide-shield-check-icon lucide-shield-check svg-stroke"
//             >
//               <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
//               <path d="m9 12 2 2 4-4" />
//             </svg>
//             <span className="mx-3">Audit</span>
//           </NavLink>
//         </li>
//         <li>
//           <NavLink to="/employee-management" aria-label="Employee Management">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="24"
//               height="24"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               stroke-width="2"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               class="lucide lucide-user-plus-icon lucide-user-plus svg-stroke"
//             >
//               <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
//               <circle cx="9" cy="7" r="4" />
//               <line x1="19" x2="19" y1="8" y2="14" />
//               <line x1="22" x2="16" y1="11" y2="11" />
//             </svg>
//             <span className="mx-3">Employees</span>
//           </NavLink>
//         </li>
//         <li>
//           <NavLink to="/hrms-reports" aria-label="HRMS Reports">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="24"
//               height="24"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               stroke-width="2"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               class="lucide lucide-file-text-icon lucide-file-text svg-stroke"
//             >
//               <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
//               <path d="M14 2v5a1 1 0 0 0 1 1h5" />
//               <path d="M10 9H8" />
//               <path d="M16 13H8" />
//               <path d="M16 17H8" />
//             </svg>
//             <span className="mx-3">Reports</span>
//           </NavLink>
//         </li>
//       </ul>
//     </div>
//   );
// };

// export default HRTabSidebar;
